const Footer = () => {
    return (
        <footer className="w-full mt-auto p-3 bg-black text-white text-center sm:text-right text-sm border-t-4 border-green-300">
            <span className="pr-3">© Copyright {new Date().getFullYear()}
                <span className="hidden sm:inline"> Noor Homeo Clinic</span>
                <span className="inline sm:hidden"> NHC</span>
            </span>
        </footer>
    );
}

export default Footer;
